"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
/**
 * *******************************
 * Functions
 * *******************************
 */
/**
 * Returns a formatted currency value
 *
 * @export
 * @param {string | number} value
 * @param {string} [currency]
 * @returns {string}
 */
function formatCurrency(value, currency) {
    if (currency === void 0) { currency = "USD"; }
    value = _1.isNullOrUndefined(value) ? 0 : value;
    var strValue = typeof value === "number" ? value : parseFloat(value).toFixed(2);
    return currency + " " + Number(strValue).toLocaleString("en");
}
exports.formatCurrency = formatCurrency;
//# sourceMappingURL=locale.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys_utils/dist/locale.js
// module id = 1199
// module chunks = 1